import { Modal } from '@carbon/react';

const DiscardChangesConfirmationModal = ({ open, onCancel, onDiscard }) => (
  <Modal
    open={open}
    size="xs"
    danger
    modalHeading="Discard unsaved changes"
    primaryButtonText="Discard"
    secondaryButtonText="Cancel"
    onRequestClose={onCancel}
    preventCloseOnClickOutside
    onRequestSubmit={onDiscard}
    onSecondarySubmit={onCancel}
  >
    <p>This page contains unsaved changes. Do you still wish to leave the page and discard any unsaved changes?</p>
  </Modal>
);

export default DiscardChangesConfirmationModal;
